// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag-tag_e47d68c2","discount":"Tag-discount_ddc2b085","promotional":"Tag-promotional_7405557d","themed":"Tag-themed_7609178d"};